import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grieveance',
  templateUrl: './grieveance.component.html',
  styleUrls: ['./grieveance.component.scss']
})
export class GrieveanceComponent implements OnInit {
  src: string = '/assets/pdf/Student Grievance Redressal Cell.pdf';
  constructor() { }

  ngOnInit(): void {
  }

}
